var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.709,
    height: 27.121,
    viewBox: "0 0 19.709 27.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "approve",
    transform: "translate(-69.963)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    width: 9.433,
    height: 24.033,
    transform: "translate(70.384 2.667)",
    fill: "#007cab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    width: 9.433,
    height: 24.033,
    transform: "translate(79.818 2.667)",
    fill: "#007cab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M111.834,84.273v20.664H122.84l4.268-4.268v-16.4Z",
    transform: "translate(-39.653 -79.809)",
    fill: "#e6eaea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910",
    transform: "translate(72.181 4.464)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 7.637,
    height: 20.664,
    transform: "translate(0)",
    fill: "#cdd4d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M319.6,393.8v4.268l4.268-4.268Z",
    transform: "translate(-308.596 -377.409)",
    fill: "#cdd4d5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M178.346,10.2a2.695,2.695,0,0,0-5.315,0H171.2v3.369h8.984V10.2Z",
    transform: "translate(-95.872 -7.529)",
    fill: "#ff8c29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M173.032,10.2H171.2v3.369h4.492V7.95A2.7,2.7,0,0,0,173.032,10.2Z",
    transform: "translate(-95.872 -7.529)",
    fill: "#c82640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M4.941,0A4.941,4.941,0,1,1,0,4.941,4.941,4.941,0,0,1,4.941,0Z",
    transform: "translate(74.876 8.507)",
    fill: "#007cab",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M162.716,165.551a4.941,4.941,0,0,0,4.885,4.941V160.61A4.941,4.941,0,0,0,162.716,165.551Z",
    transform: "translate(-87.84 -152.102)",
    fill: "#007cab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M192.577,214.663a.42.42,0,0,1-.3-.123l-1.348-1.348a.421.421,0,1,1,.6-.6l1.05,1.05,3.633-3.633a.421.421,0,0,1,.6.6l-3.931,3.931A.42.42,0,0,1,192.577,214.663Z",
    transform: "translate(-114.444 -198.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M89.251,2.246H82.81a3.116,3.116,0,0,0-5.984,0H70.384a.421.421,0,0,0-.421.421V26.7a.421.421,0,0,0,.421.421H89.251a.421.421,0,0,0,.421-.421V2.667A.421.421,0,0,0,89.251,2.246ZM87.033,20.439H83.187a.421.421,0,0,0-.421.421v3.846H72.6V4.885h2.3V6.036a.421.421,0,0,0,.421.421H84.31a.421.421,0,0,0,.421-.421V4.885h2.3V20.439Zm-.6.842-2.83,2.83v-2.83ZM79.818.842a2.265,2.265,0,0,1,2.242,1.895v.007c0,.007,0,.014,0,.021l0,.019.006.019.007.019.007.017.01.02.007.014.013.022.007.011.017.023.006.008.026.028h0l.028.026L82.217,3l.019.014.015.01.017.01.017.009.018.009.017.007.02.007.017.005.023.006.015,0,.03,0h.009l.041,0h1.414V5.615H75.747V3.088h1.462l.027,0,.015,0,.025-.006.015,0,.023-.008.016-.006.021-.01.016-.008.02-.012.014-.009L77.419,3l.013-.01.019-.017.011-.01.017-.019.009-.011.015-.02.009-.013.012-.02.009-.016.009-.019.009-.019.006-.017c0-.008.005-.015.007-.023l0-.016c0-.008,0-.017.006-.025V2.737A2.266,2.266,0,0,1,79.818.842ZM88.83,26.279H70.805V3.088h4.1v.955H72.181a.421.421,0,0,0-.421.421V25.128a.421.421,0,0,0,.421.421H83.187l.042,0,.019,0,.022,0,.021-.005.019,0,.02-.007.019-.007.018-.009.019-.009.017-.01.018-.011.018-.013.015-.011.029-.026,0,0,4.267-4.267,0,0,.026-.029.011-.015.013-.018.011-.018.01-.017.009-.019.008-.018L87.85,21l.007-.02c0-.006,0-.013,0-.019s0-.014,0-.02,0-.015,0-.023,0-.012,0-.018,0-.028,0-.042V4.464a.421.421,0,0,0-.421-.421H84.731V3.088h4.1v23.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M160.128,152.646a5.362,5.362,0,1,0,5.362,5.362A5.368,5.368,0,0,0,160.128,152.646Zm0,9.883a4.52,4.52,0,1,1,4.52-4.52A4.525,4.525,0,0,1,160.128,162.529Z",
    transform: "translate(-80.311 -144.56)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.603b50601bb8b69e615370b902c053ba.svg";
export { ForwardRef as ReactComponent };